import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Pricing } from "@/components/Pricing";
import { Calculator } from "@/components/Calculator";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Blog } from "@/components/Blog";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { useLenis } from "@/lib/useLenis";

export default function Home() {
  useLenis();

  return (
    <div className="bg-ink text-mist font-sans antialiased">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Pricing />
        <Calculator />
        <Testimonials />
        <Faq />
        <Blog />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
